import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import './social_sidebar.css';

function SocialSidebar({ icons, hoverClass }) {
    return (
        <aside className="social-sidebar">
            <div className={`social-icons-column ${hoverClass}`}>
                {icons.map((item, index) => (
                    <a
                        key={index}
                        href={item.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={item.label}
                    >
                        <FontAwesomeIcon icon={item.icon} />
                    </a>
                ))}
            </div>
        </aside>
    );
};

export default SocialSidebar;
